import { Attachment, AttachmentType } from '../../../types';
import { getSupportedFileType, SupportedFileType } from '../../common/api/uploadMedia';
import { attachmentTypeMapper, BiAttachment } from '../types';

const supportedFileTypeMapper: Record<SupportedFileType, AttachmentType> = {
  [SupportedFileType.Image]: AttachmentType.Image,
  [SupportedFileType.Gif]: AttachmentType.Image,
  [SupportedFileType.Video]: AttachmentType.Video,
};

const getAttachmentType = (file: File | Attachment): AttachmentType | undefined => {
  if (file instanceof File) {
    const supportedFileType = getSupportedFileType(file);

    return supportedFileType ? supportedFileTypeMapper[supportedFileType] : undefined;
  }

  return file.type;
};

export function getAttachmentBi(files: File[] | Attachment[]): BiAttachment[] {
  return files.map((file: File | Attachment) => {
    const attachmentType = getAttachmentType(file);
    return {
      file_name: file.name,
      file_size: file.size,
      file_type: attachmentType !== undefined ? attachmentTypeMapper[attachmentType] : null,
    };
  });
}
